'use client';

import dynamic from 'next/dynamic';

import { HappyGramForm } from '~/components/forms/happy-gram-form/form';
import { ImpactTabs } from '~/components/content-blocks/block-tabs/impact-tabs';
import { BlockCustomComponentFragment } from '~/server/generated/contentful-graphql';

const DAGSubmissionForm = dynamic(() =>
  import('~/components/forms/dag-submission-form').then((mod) => mod.DAGSubmissionForm),
);

const DAGVotingForm = dynamic(() => import('~/components/forms/dag-voting-form').then((mod) => mod.DAGVotingForm));

const FundProgramForm = dynamic(() =>
  import('~/components/forms/fund-program-form').then((mod) => mod.FundProgramForm),
);

const HospitalSponsorship = dynamic(() =>
  import('~/components/forms/hospital-sponsorship-form').then((mod) => mod.HospitalSponsorship),
);

const SearchHospitals = dynamic(() =>
  import('~/components/common/search-hospitals').then((mod) => mod.SearchHospitals),
);

export function CustomComponent({ block }: { block: BlockCustomComponentFragment }) {
  if (!block) return null;

  switch (block.componentName) {
    case 'DAG2023 Submission Form':
      return <DAGSubmissionForm />;
    case 'DAG2023 Voting Form':
      return <DAGVotingForm />;
    case 'HospitalSponsorship - Fundraise':
      // /sponsors/hospitals - fundraise-to-sponsor-a-hospital
      return <HospitalSponsorship type='Fundraise' />;
    case 'HospitalSponsorship - Donate':
      // /donate/hospitals/ - sponsor-a-hospital
      return <HospitalSponsorship type='Donate' />;
    case 'Search Hospitals':
      return <SearchHospitals />;
    case 'Search Hospitals (Homepage)':
      return (
        <SearchHospitals
          headline='National Reach, *Local Impact*'
          subhead='We place programs free of cost in more than 800 hospitals and healthcare facilities. Search for a benefiting hospital near you.'
        />
      );
    case 'Fund Program Form':
      return <FundProgramForm />;
    case 'Happy Gram Form':
      return <HappyGramForm />;
    case 'Block: Tabs - Impact':
      return <ImpactTabs />;
    default:
      return null;
  }
}
